//TODO: import the types from the vsm api
// For some reason it makes the build fail
// Related to the fact that this package is build for "lib": ["webworker"]
// import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api'
// import type { EnvironmentWixCodeSdkSiteConfig } from '../types'

const environmentWixCodeSdkSiteConfig: any = ({ api }: any) => {
	const shouldLoadSiteFeature = api.features.isActive('platform')

	const shouldLoadSiteConfig = shouldLoadSiteFeature

	return {
		shouldLoadSiteFeature,
		shouldLoadSiteConfig,
		siteConfig: null,
	}
}

const name = 'environmentWixCodeSdk'

export const config = { site: environmentWixCodeSdkSiteConfig, name }
